<template>
  <div class="loading">
    <loading color="#0f8de9" size="40" />
    <div class="loading-text" >
      {{ loadingText }}
    </div>
    <div class="sub-text">
      跳转过程中请勿关闭页面
    </div> 
  </div>
</template>

<script>
import { parseQueryString } from '@/business/utils/string'
import { Loading, Toast } from 'vant'
import { fkLogin } from '@/business/config/interceptors/router'

export default {
  name: 'trace',
  components: {
    Loading
  },
  data() {
    return {
      loadingText: '正在验证授权信息，请稍候...'
    }
  },
  created() {
    // console.log('trace-created', this.$route.query, parseQueryString())
    this.toFkLogin()
  },
  mounted() {
    // console.log('trace-mounted', this.$route.query, parseQueryString())
  },
  beforeRouteEnter (to, from, next) {
    // console.log('trace-beforeRouteEnter', to, from, parseQueryString())
    // next()

    // 使用 next 回调进行路由跳转，确保触发全局守卫
    next(vm => {
      // setTimeout(() => {
      //   vm.$router.push({
      //     path: '/home',
      //     query: { t: Date.now() }
      //   }).catch(err => {
      //     console.log('trace-beforeRouteEnter-err', err)
      //   })
      // }, 500)
    })
  },
  beforeRouteLeave (to, from, next) {
    // console.log('trace - beforeRouteLeave', to, from, next, parseQueryString());
    next()
  },
  methods: {
    goHome() {
      this.$router.push({
        path: '/home',
        query: { t: Date.now() }
      }).catch(err => {
        console.log('trace-beforeRouteEnter-err', err)
      })
    },
    toFkLogin() {
      const urlParams = parseQueryString()
      const userInfo = this.$store.getters.userInfo
      if(userInfo.empInfo) {
        this.goHome()
        return
      }
      // 授权超时，请重新授权
      const timeout = setTimeout(() => {
        Toast.fail({message: '授权超时，请重新授权', duration: 3000, onClose: () => {
          this.goHome()
        }})
      }, 10000);

      if (Object.keys(urlParams).length > 0 && urlParams.code && urlParams.code.length > 10 && urlParams.state && /^fk#/.test(urlParams.state)) {
        clearTimeout(timeout)
        fkLogin(urlParams, () => {
          window.location.href = '/#/login?tt=' + Date.now()
        })
      }
    }
  }
}
</script>

<style scoped>
.loading {
  width: 100%;
  height: 100%;
  padding-top: 100px;
  font-size: 16px;
  color: #666;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.loading-text {
  padding-top: 15px;
}
.sub-text {
  margin-top: 8px;
  font-size: 14px;
  color: #999;
}
</style>
